import { Link } from 'react-router-dom'
import { useTranslation } from '../../i18n'
import './DownloadCTA.css'

function DownloadCTA() {
  const { t } = useTranslation()

  return (
    <section id="download-cta" className="section download-cta-section" aria-label="Download the app">
      <div className="container">
        <div className="download-cta-content">
          <div className="download-cta-header">
            <span className="download-cta-badge">{t('downloadCtaBadge')}</span>
            <h2>{t('downloadCtaTitle')}</h2>
            <p>{t('downloadCtaSubtitle')}</p>
          </div>

          <div className="download-cta-actions">
            <Link to="/download" className="btn btn-primary btn-large download-cta-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              {t('downloadCtaButton')}
            </Link>
          </div>

          <div className="download-cta-features">
            <div className="download-cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('downloadCtaFeature1')}</span>
            </div>
            <div className="download-cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('downloadCtaFeature2')}</span>
            </div>
            <div className="download-cta-feature">
              <span className="feature-check">✓</span>
              <span>{t('downloadCtaFeature3')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DownloadCTA
